<template>
  <section id="LoginPage" class="hero is-primary is-fullheight">
    <div class="hero-body">
      <div class="container">
        <div class="columns is-centered is-mobile">
          <div
            class="column is-4-desktop is-6-tablet is-8-mobile"
            style="padding: 0"
          >
            <login-card />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import LoginCard from "@/components/cards/LoginCard.vue";

export default {
  name: "LoginPage",
  components: {
    LoginCard
  }
};
</script>
